module.exports = __webpack_public_path__ + "img/header_default.40cecce2.png";